<script lang="ts">
import { computed, defineComponent, toRef } from 'vue'
import BridgeChildRender from './child/BridgeChild.vue'
import { useCustomization } from '@/hooks/useCustomization'
import { useEnhancer } from '@/app/enhancer'
import CardHeader from '@/components/ui/card/CardHeader.vue'
export default defineComponent({
  name: 'GoBridge',
  components: { CardHeader, BridgeChildRender },
  emits: ['back'],
  setup(_, { emit }) {
    const customization = useCustomization()
    const { storeFavorites } = useEnhancer()

    const bridgeData = computed(() => customization.getBridgeData.value)

    const setBridge = (value: string) => {
      const bridge = bridgeData.value.find(item => item.value === value)
      storeFavorites.setCurrentConfig('bridge', bridge)
    }

    return {
      currentBridge: toRef(storeFavorites, 'selectedBridgeName'),
      bridgeOptions: customization.getBridgeOptions,
      setBridge,
      handleClose: () => {
        emit('back')
      },
    }
  },
})
</script>

<template>
  <div class="animate_500">
    <CardHeader
      title="BRIDE"
      description="ブリッジ"
      hidden-left
      @close="handleClose"
    />
    <div class="row full-height items-center q-col-gutter-md q-px-md q-py-sm">
      <BridgeChildRender
        v-for="(item, index) in bridgeOptions"
        :key="item.key"
        :index="index"
        :item="item"
        :current-bridge="currentBridge"
        @set-bridge="setBridge"
      />
    </div>
  </div>
</template>
